module.exports = __webpack_public_path__ + "img/network_default.57b06603.png";